import apiClient from '../../../services/apiClient';

export const AuthTransfersAPI = {
  login: async (credentials: { email: string; password: string }) => {
    const requestBody = {
      ...credentials,
      portal: true,
    };
    const response = await apiClient.post("/api/login", requestBody);
    return response.data
  },

  logout: async () => {
    return await apiClient.post('/api/logout');
  },
};
